import React, { useState } from 'react'
import TopMenu from './TopMenu'
import SideMenu from '../sidebar/SideMenu'
import MyFooter from './MyFooter'
import ImpersonationBanner from './ImpersonationBanner'

function MainStructure({children , activeItem}) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sp_sidebar_collapsed') === 'true');

  const toggleCollapsed = () => setCollapsed(c => {
    const next = !c;
    localStorage.setItem('sp_sidebar_collapsed', next);
    return next;
  });

  return (


    <div className="wrapper">

                    <SideMenu activeItem={activeItem} collapsed={collapsed}></SideMenu>

                    <div className="main">
                                    <ImpersonationBanner />
                                    <TopMenu onSidebarToggle={toggleCollapsed}></TopMenu>
                                


                                    <main className="content">
                                        {children}
                                    </main>
                                    
                                    <MyFooter></MyFooter>

                    </div>
    </div> 


  )
}

export default MainStructure